module.exports = __webpack_public_path__ + "img/guide-tripwe-app.0497ff17.jpg";